import * as React from 'react';
import {Variants, motion} from 'framer-motion';

const line: Variants = {
  initial: {
    y: 50,
    opacity: 0,
  },
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.75,
      delay: 0.5,
      ease: 'easeOut',
    },
  },
};

const topBottomLine: Variants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition: {
      duration: 1,
      delay: 1,
      ease: 'easeInOut',
    },
  },
};

const pathVariants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition: {
      delay: 0.75,
      duration: 1,
      ease: 'easeInOut',
    },
  },
};

type Props = React.HTMLAttributes<SVGElement>;

const StepOneDiagram: React.FC<Props> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={326}
    height={290}
    fill="none"
    {...props}
  >
    <motion.g
      initial="initial"
      animate="animate"
      variants={line}
      clipPath="url(#a)"
      opacity={0.5}
    >
      <path
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth={0.5}
        d="M153.995 36.58c-3.507-.148-7.083-.705-10.599-.488-3.526.212-6.456 1.603-8.103 4.774 0 0 0 .01-.005.015l-.178.34c-.187.36-.375.72-.562 1.075l-.178.336c-.177.345-.36.69-.547 1.035a3.978 3.978 0 0 1-.173.32c-.167.326-.34.652-.517.977l-.015.03h-.005c-.054.108-.114.212-.168.32-.177.316-.355.637-.537.947l-.188.311c-.187.306-.385.602-.587.893a6.822 6.822 0 0 1-.227.3c-.019.025-.039.055-.059.08-1.282 1.637-2.984 2.668-4.552 3.985-1.194 1.006-2.293 2.18-3.374 3.31a119.11 119.11 0 0 0-4.379 4.828c-1.741 0-5.637-4.143-5.85-4.666-.207-.523 1.672-3.724 1.638-4.316-.035-.591.207-1.218.207-1.218 2.367-3.797 18.939-22.978 19.531-23.57.592-.592 2.51-1.39 2.51-1.39s15.664-4.296 18.835-5.105c.232-.06.607.335.814.04.212-.297.671-.36 1.1-.09.429.272.138-.695.345-.695.207 0 9.613-.695 9.613-.695s1.321-.282 1.736 1.598c.419 1.879 1.326 13.158 1.396 14.554.004.099.004.187 0 .266"
      />
      <path
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth={0.5}
        d="M134.099 26.72c.439 1.278 2.244 1.234 3.339 1.337 1.948.178 3.822-.207 5.677-.789 1.978-.621 3.926-1.4 5.977-1.682 1.554-.212 3.191.094 3.902 1.658.67 1.474.838 3.107 1.159 4.675.32 1.568 1.001 3.157 1.632 4.705"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={0.5}
        d="M118.465 45.234c.365 1.371 2.377 1.588 3.536 1.588 1.899 0 3.295-.996 4.454-2.446 1.085-1.361 1.889-2.925 2.855-4.37.908-1.356 1.968-2.648 3.339-3.536 1.815-1.179 4.035-1.554 6.2-1.672 2.165-.119 4.34-.015 6.48-.345"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={0.5}
        d="M138.888 37.195c-1.129.296-2.318.02-3.442.296-1.021.251-1.889.952-2.595 1.706-1.854 1.983-3.689 3.975-5.326 6.15-.38.503-.755 1.041-.873 1.657-.202 1.08.75 1.875 1.401 2.61"
      />
      <path
        fill="#fff"
        d="M135.293 40.864s0 .01-.005.015l-.178.34a2.839 2.839 0 0 1-.478-.734l-.109-.237a.183.183 0 0 1 .104-.232.19.19 0 0 1 .247.099l.103.237c.079.177.188.35.316.513ZM134.371 42.63c-.341-.3-.612-.66-.78-1.04l-.103-.237c-.04-.089 0-.193.103-.232a.188.188 0 0 1 .242.094l.104.241c.133.296.345.587.611.839l-.177.335ZM133.823 43.666a3.978 3.978 0 0 1-.173.32c-.483-.34-.882-.804-1.095-1.292l-.108-.237c-.04-.088.005-.192.104-.231a.199.199 0 0 1 .246.093l.104.237c.182.41.518.804.922 1.11ZM133.113 44.993c-.055.109-.114.212-.168.32-.626-.354-1.169-.912-1.43-1.513l-.109-.242a.177.177 0 0 1 .104-.227c.098-.04.207 0 .246.094l.104.236c.227.518.705 1.017 1.253 1.332ZM132.22 46.573c-.755-.326-1.44-.972-1.746-1.672l-.104-.232c-.044-.094.001-.197.099-.237a.2.2 0 0 1 .247.099l.103.237c.277.621.913 1.208 1.588 1.494l-.187.31ZM131.633 47.465a6.76 6.76 0 0 1-.227.301c-.838-.286-1.632-.986-1.972-1.76l-.104-.232a.178.178 0 0 1 .104-.237.193.193 0 0 1 .241.099l.109.236c.306.7 1.075 1.362 1.849 1.593Z"
      />
      <path
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth={0.5}
        d="M156.525 19.67s-.947 9.697 1.514 16.834M157.94 19.429s-1.011 10.007 1.45 17.139"
      />
      <path
        fill="#fff"
        d="M163.262 39.273c-29.957 0-54.326 24.418-54.326 54.434 0 8.665 1.973 16.946 5.859 24.615a53.908 53.908 0 0 0 7.872 11.551 54.306 54.306 0 0 0 40.595 18.268c7.62 0 14.988-1.548 21.898-4.606a54.242 54.242 0 0 0 16.315-11.137l.02-.019s.029-.03.044-.05l.074-.069a53.867 53.867 0 0 0 3.043-3.299c.074-.084.143-.173.212-.257.168-.197.331-.394.493-.597l.178-.217c.247-.305.493-.616.735-.932.246-.315.483-.636.715-.952.237-.325.469-.646.7-.971.272-.385.538-.779.799-1.169.252-.37.489-.745.735-1.129.04-.06.074-.114.099-.163.172-.271.34-.538.493-.804.123-.192.237-.39.345-.582.114-.192.232-.39.331-.572.118-.197.222-.39.34-.602.207-.375.409-.755.607-1.134.207-.39.409-.789.601-1.184.114-.232.227-.464.336-.7 0-.005 0-.01.005-.015.044-.094.088-.183.128-.276.266-.558.518-1.125.725-1.608l.025-.059c.054-.119.103-.242.148-.365l.059-.148a4.55 4.55 0 0 0 .118-.296c.316-.77.612-1.549.893-2.333 0-.01 0-.015.005-.025.823-2.747 1.721-5.879 2.12-7.807.035-.158.065-.311.089-.454l.03-.177c.143-.789.271-1.593.375-2.412.088-.612.157-1.228.222-1.85 0-.014.005-.034.005-.049.029-.276.054-.552.073-.833a53.98 53.98 0 0 0 .193-4.582c0-30.016-24.369-54.434-54.326-54.434Zm53.566 59.8a53.034 53.034 0 0 1-.592 4.281l-.029.168c-.03.172-.069.355-.109.552a51.367 51.367 0 0 1-2.081 7.625c0 .015-.005.024-.01.039a53.708 53.708 0 0 1-.883 2.313 6.283 6.283 0 0 1-.113.286l-.069.168a5.907 5.907 0 0 1-.153.375l-.03.069a42.484 42.484 0 0 1-.7 1.554c-.143.325-.301.651-.464.976-.192.395-.394.784-.591 1.174-.198.38-.4.75-.612 1.139-.108.188-.212.38-.33.577-.104.193-.212.38-.331.572-.103.193-.217.38-.335.572a22.96 22.96 0 0 1-.498.809 1.5 1.5 0 0 1-.099.158c-.237.375-.473.745-.72 1.11-.257.389-.523.779-.799 1.164-.227.32-.449.641-.686.957-.231.315-.468.636-.71.946-.237.311-.483.622-.73.923l-.172.217c-.163.197-.321.394-.494.592a4.738 4.738 0 0 1-.212.251c-.207.257-.429.503-.651.755a50.567 50.567 0 0 1-2.357 2.51h-.148v.148a53.73 53.73 0 0 1-16.157 11.028c-6.851 3.033-14.15 4.567-21.701 4.567-15.358 0-30.021-6.599-40.23-18.1a53.597 53.597 0 0 1-7.793-11.452c-3.857-7.596-5.81-15.803-5.81-24.39 0-29.744 24.147-53.94 53.833-53.94s53.833 24.196 53.833 53.94c0 1.801-.089 3.606-.267 5.367Z"
      />
      <path
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth={0.5}
        d="M205.914 60.393c-2.274-2.905-5.055-5.662-6.639-7.107-4.325-3.95-8.936-6.668-13.188-8.715-4.226-2.032-8.093-3.408-12.576-4.074-8.242-1.228-16.157-1.257-22.964.528-5.4 1.416-6.436 1.79-9.153 2.836-3.694 1.42-.242-3.507 12.601-7.28H154c1.391.055 2.969.08 4.241-.01 2.994-.207 11.98-.971 11.98-.971s.661.178.696-.917c14.884 1.4 26.849 11.274 33.384 19.925 4.779 6.323 3.467 8.152 1.613 5.785Z"
      />
      <path
        fill="#fff"
        d="M218.791 100.611c-.212-1.607-.508-2.328-.981-2.416a.555.555 0 0 0-.414.094c-.227.152-.405.448-.538.69l-.03.094a53.479 53.479 0 0 1-.591 4.281l-.03.167c-.03.173-.069.355-.109.553a51.367 51.367 0 0 1-2.081 7.625c0 .014-.005.024-.01.039a383.779 383.779 0 0 1-1.627 5.243c-.005.005-.005.01-.005.015-.054.162-.079.251-.084.261l-.02.059c-2.051 7.29-3.837 11.018-7.417 17.785-1.47 2.782-4.76 7.935-6.516 10.017-12.098 17.765-27.777 25.774-46.597 23.806-18.613-1.943-31.693-11.225-38.874-27.579-6.86-15.62-6.851-33.834-6.846-44.719v-.345c0-2.801.257-5.76.76-8.808 2.564-15.413 10.618-28.044 10.697-28.172l.124-.192-.183-.138s-1.351-1.036-1.859-1.505c-.271-.246-.72-.715-.957-.966-.429-.459-.814-.883-.814-.883l-.222-.232-.172.271c-.957 1.505-9.416 15.171-12.029 31.407-.508 3.167-.765 6.269-.765 9.218v.37c0 10.5 0 28.078 6.195 44.151 7.718 20.004 22.652 31.299 44.388 33.567 1.938.208 3.925.311 5.908.311 9.154 0 17.721-2.333 25.474-6.88s14.697-11.299 20.616-20.137c4.3-6.432 8.029-13.578 10.495-20.113 3.842-10.19 5.894-21.015 5.114-26.939Zm-5.578 26.761c-1.228 3.251-2.767 6.654-4.532 10.047a107.077 107.077 0 0 1-5.914 9.967c-11.738 17.534-27.535 26.801-45.675 26.801-1.963 0-3.936-.104-5.859-.311-21.533-2.249-36.329-13.435-43.974-33.251-6.165-15.99-6.165-33.508-6.165-43.999v-.345c0-2.925.257-5.997.755-9.149 2.486-15.407 10.268-28.492 11.792-30.943.153.168.37.404.602.646.247.261.7.735.981.996.42.38 1.332 1.095 1.722 1.396-1.026 1.652-8.242 13.696-10.648 28.182-.513 3.057-.77 6.046-.77 8.872v.345c0 10.925-.015 29.203 6.885 44.916 7.26 16.532 20.473 25.908 39.279 27.876 1.879.197 3.723.291 5.543.291 16.567 0 30.509-8.158 41.493-24.295 1.894-2.239 5.238-7.576 6.564-10.081 3.596-6.802 5.391-10.545 7.468-17.918.014-.05.823-2.555 1.716-5.519 0-.01 0-.015.005-.025.823-2.747 1.721-5.879 2.121-7.807.034-.158.064-.311.088-.454l.03-.177c.143-.79.271-1.593.375-2.412a44.6 44.6 0 0 0 .222-1.85c.133-.236.231-.36.301-.424.069-.064.103-.069.103-.069.005.005.326.084.577 2.002.774 5.845-1.267 16.577-5.085 26.692Z"
      />
    </motion.g>
    <motion.circle
      variants={line}
      initial="initial"
      animate="animate"
      cx={163}
      cy={94}
      r={55}
      stroke="#fff"
      strokeWidth={2}
    />
    <motion.path
      initial="initial"
      animate="animate"
      variants={line}
      fill="#fff"
      d="M171.269 91.573h-6.421L167.395 82 155 96.754h6.421l-2.547 9.573 12.395-14.754Z"
    />
    <motion.path
      variants={topBottomLine}
      initial="initial"
      animate="animate"
      id="top-line"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M171.006 188H155"
    />
    <motion.path
      stroke="#fff"
      strokeDasharray="0.05 4"
      strokeLinecap="round"
      d="M163 193v90"
      variants={pathVariants}
      initial="initial"
      animate="animate"
    />

    <motion.path
      variants={topBottomLine}
      initial="initial"
      animate="animate"
      id="bottom-line"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M171.006 287H155"
    />
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M100.601 18h118.353v156.68H100.601z" />
      </clipPath>
    </defs>
  </svg>
);
export default StepOneDiagram;
